import { configureStore } from "@reduxjs/toolkit";
import usersSlice from './Slices/users/usersSlice'
import BranchesSlice from './Slices/Branches/BranchesSlice'
import PackagesSlice from './Slices/Packages/PackagesSlice'
import CategoriesSlice from './Slices/Categories/CategoriesSlice'
import ServicesSlice from './Slices/Services/ServicesSlice'
import cartsSlice from './Slices/Cart/CartSlice'
import reservationSlice from './Slices/reservation/ReservationSlice'
import paymentSlice from './Slices/payment/paymentSlice'
import TimeSlice from './Slices/Time/TimeSlice'



export const store = configureStore({
  reducer: {
    usersSlice,
    BranchesSlice,
    PackagesSlice,
    CategoriesSlice,
    ServicesSlice,
    cartsSlice,
    reservationSlice,
    paymentSlice,
    TimeSlice
  },
});
